/**

 About ua-parser-js:

 getBrowser()
 returns { name: '', version: '' }

 # Possible 'browser.name':
 Amaya, Android Browser, Arora, Avant, Baidu, Blazer, Bolt, Bowser, Camino, Chimera,
 Chrome [WebView], Chromium, Comodo Dragon, Conkeror, Dillo, Dolphin, Doris, Edge,
 Epiphany, Fennec, Firebird, Firefox, Flock, GoBrowser, iCab, ICE Browser, IceApe,
 IceCat, IceDragon, Iceweasel, IE[Mobile], Iron, Jasmine, K-Meleon, Konqueror, Kindle,
 Links, Lunascape, Lynx, Maemo, Maxthon, Midori, Minimo, MIUI Browser, [Mobile] Safari,
 Mosaic, Mozilla, Netfront, Netscape, NetSurf, Nokia, OmniWeb, Opera [Mini/Mobi/Tablet],
 PhantomJS, Phoenix, Polaris, QQBrowser, RockMelt, Silk, Skyfire, SeaMonkey, Sleipnir,
 SlimBrowser, Swiftfox, Tizen, UCBrowser, Vivaldi, w3m, WeChat, Yandex
 ===========

 getDevice()
 returns { model: '', type: '', vendor: '' }

 # Possible 'device.type':
 console, mobile, tablet, smarttv, wearable, embedded
 ===========

 getOS()
 returns { name: '', version: '' }

 # Possible 'os.name'
 AIX, Amiga OS, Android, Arch, Bada, BeOS, BlackBerry, CentOS, Chromium OS, Contiki,
 Fedora, Firefox OS, FreeBSD, Debian, DragonFly, Gentoo, GNU, Haiku, Hurd, iOS,
 Joli, Linpus, Linux, Mac OS, Mageia, Mandriva, MeeGo, Minix, Mint, Morph OS, NetBSD,
 Nintendo, OpenBSD, OpenVMS, OS/2, Palm, PC-BSD, PCLinuxOS, Plan9, Playstation, QNX, RedHat,
 RIM Tablet OS, RISC OS, Sailfish, Series40, Slackware, Solaris, SUSE, Symbian, Tizen,
 Ubuntu, UNIX, VectorLinux, WebOS, Windows [Phone/Mobile], Zenwalk

 More info at https://www.npmjs.com/package/ua-parser-js
 */
import UAParser from "ua-parser-js";
import { BROWSER, OS } from "../const/constants";

// We can pull data once because browser doesn't change while runtime
const uAParser = new UAParser();
const browser = uAParser.getBrowser();
const os = uAParser.getOS();
const cpu = uAParser.getCPU();
const device = uAParser.getDevice();

const AMD64 = "amd64";
const WIN11 = 11;
const WIN12 = 12;

function contains(stringA, stringB) {
  console.log("stringA", stringA);
  console.log("stringB", stringB);
  console.log("res", stringA.toLowerCase().indexOf(stringB.toLowerCase()));
  if (stringA && stringA.length && stringB) {
    return stringA.toLowerCase().indexOf(stringB.toLowerCase()) !== -1;
  }
}

/**
 * BROWSER
 */

export const isChrome = () => contains(browser.name, BROWSER.CHROME);
export const isFirefox = () => contains(browser.name, BROWSER.FIREFOX);
export const isSafari = () => contains(browser.name, BROWSER.SAFARI);

export const isIE = () => contains(browser.name, BROWSER.IE);
export const isIE11 = () => isIE() && parseInt(browser.major) === WIN11;
export const isIE12 = () => isIE() && parseInt(browser.major) === WIN12;

export const isEdge = () => contains(browser.name, BROWSER.EDGE);

export const getMajorBrowserVersion = () => parseInt(browser.major);

/**
 * OPERATING SYSTEMS
 */

export const isIOS = () => contains(os.name, OS.IOS);
export const isMac = () => contains(os.name, OS.MAC);
export const isAndroid = () => contains(os.name, OS.ANDROID);
export const isWindows = () => contains(os.name, OS.WIN);

export const is64Bit = () => cpu.architecture === AMD64;
export const is32Bit = () => !is64Bit();

/**
 * DEVICE
 */

export const isMobileBrowser = () =>
  contains(device.type, "mobile") || contains(device.type, "tablet");
export const isIphoneOrIpod = () =>
  contains(navigator.userAgent, "iphone") ||
  contains(navigator.userAgent, "ipod");

export function listCookies() {
  const cookiesArray = document.cookie.split(";");
  const result = [];
  for (let i = 0; i < cookiesArray.length; i++) {
    const pairCookie = cookiesArray[i].split("=");
    if (pairCookie[0] && pairCookie[1]) {
      result.push({ name: pairCookie[0].trim(), value: pairCookie[1].trim() });
    }
  }
  return result;
}

export function isEuUser(code) {
  const euCountries = {
    BE: "Belgium",
    EL: "Greece",
    LT: "Lithuania",
    PT: "Portugal",
    BG: "Bulgaria",
    ES: "Spain",
    LU: "Luxembourg",
    RO: "Romania",
    CZ: "Czech Republic",
    FR: "France",
    HU: "Hungary",
    SI: "Slovenia",
    DK: "Denmark",
    HR: "Croatia",
    MT: "Malta",
    SK: "Slovakia",
    DE: "Germany",
    IT: "Italy",
    NL: "Netherlands",
    FI: "Finland",
    EE: "Estonia",
    CY: "Cyprus",
    AT: "Austria",
    SE: "Sweden",
    IE: "Ireland",
    LV: "Latvia",
    PL: "Poland",
    UK: "United Kingdom"
  };
  return !!euCountries[code];
}



// WEBPACK FOOTER //
// ./src-cookie-manager/utils/browser.js